import React, { useEffect, useState, useMemo, useRef } from "react";
import { useHistory } from "react-router-dom";
import { candidateLogout } from "../services/AuthService";
import firebase from "firebase/compat/app";
import bgimage from "../assets/img/images/teamanics_logo.svg";
import { getBasicInfoDetails } from "../../src/services/ProfileService";
import { ENV, isNullOrEmpty } from "../config/ENV";
import { ProfileService } from "../../src/services/ProfileService";

const Header = () => {
  let count = 0;
  const history = useHistory();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [title, setTitle] = useState("");
  const [notification, setNotification] = useState([]);
  const [createdStatusCount, setCreatedStatusCount] = useState();
  useEffect(() => {
    //  getCandidateBasicInfoDetails();
    if (isNullOrEmpty(window.localStorage.getItem("name"))) {
      setFirstName("");
    } else {
      setFirstName(window.localStorage.getItem("name"));
    }

    if (isNullOrEmpty(window.localStorage.getItem("lastName"))) {
      setLastName("");
    } else {
      setLastName(window.localStorage.getItem("lastName"));
    }

    if (!isNullOrEmpty(window.localStorage.getItem("page"))) {
      if (window.localStorage.getItem("page") == "proxylogin") {
        setTitle("TA’s View of ");
      } else {
        setTitle("Hi,");
      }
    } else {
      setTitle("Hi,");
    }
  }, [count]);

  useEffect(() => {
    getCandidateNotificatiosList();
  }, []);

  const getCandidateNotificatiosList = () => {
    ProfileService.getNotifications().then((response) => {
      setNotification(response.data.notifications);
      setCreatedStatusCount(response.data.newEvents);
    });
  };

  const updateApi = (id) => {
    ProfileService.updateNotifications(id).then((response) => {
      try {
        let dataCheck = response.data;
        if (dataCheck !== null) {
          getCandidateNotificatiosList();
          //setReadNotification(notificationId)
        }
      } catch (error) {
        console.log("readNotification" + JSON.stringify(error));
      }
    });
  };

  const navigateTo = (id) => {
    window.localStorage.setItem("notificationIds", id);
    updateApi(id);

    history.push("/notification");
  };

  const gotoNotification = () => {
    history.push("/notification");
  };

  const discourseOnClick = () => {
    // window.localStorage.removeItem("page");
    // const discourse_url=ENV.discourse_session_url;
    // window.open(discourse_url, '_blank');
  };
  return (
    <>
      <header className="bg-gradient-to-br from-primary-blue3 to-primary-blue min-md:fixed top-0 w-screen max-md:h-[8vh] max-md:-z-10 min-md:z-0 min-md:h-16 shadow-primary-gray t-w-screen "></header>
      <div className="container">
        <div className=" min-md:ml-9 w-32 top-[24px]  fixed max-md:absolute z-30 max-md:ml-6">
          <a href="#">
            <img src={bgimage} alt="Teamanics" />
          </a>
        </div>
      </div>
      <div className="headerMenu min-md:fixed min-md:top-0 min-md:w-screen ">
        <div className="header-wrapper ">
          <div className="headerWelcome text-[20px] min-md:fixed z-20 min-md:right-9 min-md:top-5 flex flex-col gap-1 min-md:flex-row-reverse min-md:items-center max-md:absolute max-md:top-12 max-md:header-left-text max-md:pt-8 max-md:px-6 text-primary-white font-assistant">
            <div
              className="  max-md:text-2xl font-semibold max-md:hidden mr-1 t-header-name"
              onClick={discourseOnClick}
            >
              {title} <>{firstName + " " + lastName}</>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
